import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Title} from '@angular/platform-browser';

import {TerraUtils} from 'src/app/shared/TerraUtils';

@Component({
  selector: 'terra-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManageUsersComponent implements OnInit {
  paths = TerraUtils.consts.paths;

  constructor(
    private titleService: Title
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(`Manage Users ${TerraUtils.consts.GpPageTitleSuffix}`);
  }
}
